var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("ChangeShipmentStatus")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.showdetails('form')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingId),
      expression: "ShippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormat'),
      expression: "'required|VerifyShippingidFormat'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipment Id",
      "name": "ShippingId",
      "id": "ShippingId"
    },
    domProps: {
      "value": (_vm.ShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2 mb-4",
    attrs: {
      "type": "submit",
      "disabled": _vm.isShipmentLoader,
      "size": "sm"
    }
  }, [_vm._v("Show Items")]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger mb-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isShipmentLoader,
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm1
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isShipmentLoader,
      "text": "Please wait shipment is in processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isShipmentLoader = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.ShippingId')),
      expression: "errors.has('form.ShippingId')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(_vm._s(_vm.errors.first('form.ShippingId')))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invalidshipments.length > 0),
      expression: "invalidshipments.length > 0"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(" Invalid Shipments : " + _vm._s(_vm.invalidshipments))])])])])])]), _vm._v(" "), (_vm.showTable == true) ? _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmMarkShipmentLost('form-1')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isShipmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isShipmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }],
    ref: "comments",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "rows": "2",
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comment"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success mr-6 mb-4",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.ShipmentStatus.length == 0
    }
  }, [_vm._v("Mark Shipment Lost")]), _vm._v(" \n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter comment")])])])])], 1), _vm._v(" "), _c('div', [_vm._v("\n      Total Records: " + _vm._s(_vm.ShipmentStatus.length) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.showTable == true) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoader,
      "text": "Please wait..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoader = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.selfdebitflag == true) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Result")])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ShipmentStatus), function(data, index) {
    return _c('tr', {
      key: index
    }, [(_vm.selfdebitflag == true) ? _c('td', {
      style: (data.code == 200 ? 'color:green;' : 'color:red')
    }, [_vm._v(_vm._s(data.response))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeclaredValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.LastModifiedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OriginHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FinalDestinationHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubName))])])
  }), _vm._v(" "), (_vm.ShipmentStatus == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)], 1) : _vm._e()])]) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipment Id:")]), _vm._v(" \n                    ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample-awb-eg col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" Multiple shipping IDs can be separated using comma or next line (,/↵).")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                 Comments: ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShipmentStatus")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OrderType")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OctroiMRP")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("NetPayment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OriginHubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("FinalDestinationName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CurrentHubName")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337624a6","hasScoped":true}!./src/views/components/LOST/CheckShipmentStatus/CheckShipmentStatus.component.html
// module id = 1394
// module chunks = 1